<template>
  <!-- @vue-expect-error todo fix me -->
  <div :class="`metapic-input metapic-input-flex`" :style="`width: ${(col / 12) * 100}%;`">
    <div class="metapic-input-label">{{ label }}</div>
    <el-select :model-value="modelValue" size="large" :placeholder="placeholder" @change="updateData">
      <!-- @vue-expect-error todo fix me -->
      <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value"> </el-option>
    </el-select>
  </div>
</template>
<script lang="ts">
export default {
  name: 'MSelect',
  components: {},
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      required: true,
    },
    options: {
      required: true,
      type: Array,
    },
    placeholder: {
      required: false,
      default: '',
      type: String,
    },
    col: {
      type: [Number, String],
      default: 12,
    },
  },
  emits: ['change', 'update:modelValue'],
  methods: {
    updateData(newValue) {
      this.$emit('update:modelValue', newValue)
      this.$emit('change')
    },
  },
}
</script>
<style scoped lang="scss">
/* metapic input */
.el-select {
  margin: 0;
  width: 100%;
}
.metapic-input {
  position: relative;
}
.metapic-input-label {
  position: absolute;
  top: 8px;
  left: 16px;
  z-index: 12;
  font-size: 14px;
  line-height: 18px;
}
.metapic-input-flex {
  float: left;
  padding-right: 16px;
  margin-bottom: 18px;
}
:deep(.el-select) {
  .el-select__placeholder {
    top: 10px;
  }
}
</style>
<style>
.metapic-input .el-input .el-input__inner {
  line-height: 20px;
  font-size: 16px;
  padding-top: 28px;
  padding-bottom: 8px;
  height: 56px;
}
</style>
